var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "help",
    "data-name": "help",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "help-1",
    d: "M130.4,200.76c-5.65,0-10.6-5.18-10.6-11.08a10.73,10.73,0,0,1,21.45,0A11.12,11.12,0,0,1,130.4,200.76Zm-7.26-32.49-.43-23,31.11-37.4c4.9-6.2,6.89-11.87,6.89-19.62,0-16.4-13-29.74-28.93-29.74-16.1,0-29.2,13.94-29.2,31.09v2.89H86V88c0-25.52,20.12-45.52,45.79-45.52,25.09,0,45.51,19.94,45.51,44.44a48,48,0,0,1-10.68,29.23l-26.76,32.34-.71,19.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "help-1",
    d: "M133.26.13A122.73,122.73,0,0,0,21.76,174.21L.38,256l85.36-19.92A122.76,122.76,0,1,0,133.26.13Zm0,231.14c-15.09,0-29.46-5.17-42.53-10.76L19.59,237.38l18-61.52c-6.81-14.17-12.69-36.22-12.69-53A108.38,108.38,0,1,1,133.26,231.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.c1b2839c.svg";
export { ForwardRef as ReactComponent };